import { submitForm } from "../../../stores/request";
import { useNavigate } from "react-router";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Button,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import StyledHeader from "../../../components/StyledHeader/StyledHeader";
import { useCallback, useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import {
  ArticleOutlined,
  Input,
  CloudUploadOutlined,
  Upload,
} from "@mui/icons-material";
import FastaForm from "../../../components/FastaForm/FastaForm";
import { useSnackbar } from "notistack";
import checkFasta from "../../../utils/fastaValidator";

export default function ProteinPrediction(store) {
  // const [useCustomModel, setUseCustomModel] = useState(true);
  const gotoExample = () => {
    window.open("#/result?jobId=2023010268", "_blank");
  };
  const [defaultTask, setDefaultTask] = useState("");
  const [fasta, setFasta] = useState("");
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [uploading, setUploading] = useState(false);
  const [inputFile, setInputFile] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const [resultData, setResultData] = useState({
    jobId: null,
    requestTime: "2021-09-23 14:36:13",
    status: "waiting",
  });
  const showModal = async (data) => {
    await setResultData({
      jobId: data.jobId,
      requestTime: data.requestTime,
      status: data.status,
    });
    await setIsModalVisible(true);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);

  const submit = async () => {
    let formData = new FormData();
    if (inputFile) {
      formData.append("dataFile", inputFile, inputFile.name);
      formData.append("dataStr", "");
    } else {
      if (fasta.length <= 0) {
        enqueueSnackbar("Please enter the sequence or select one FASTA file", {
          variant: "error",
        });
        return;
      }
      let check_fasta_format = checkFasta(
        fasta,
        enqueueSnackbar,
        "Detectability",
        false
      );
      if (!check_fasta_format) {
        return false;
      }
      formData.append("dataStr", fasta);
    }

    if (email.length < 1) {
      enqueueSnackbar("Please input your e-mail", { variant: "error" });
      return;
    }


    //dataStr, dataFile, param, mail
    // formData.append(
    //   "dataStr",
    //   ">1a81_A\nSANHLPFFFGNITREEAEDYLVQGGMSDGLYLLRQSRNYLGGFALSVAHGRKAHHYTIERELNGTYAIAGGRTHASPADLCHYHSQESDGLVCLLKKPFNRPQGVQPKTGPFEDLKENLIREYVKQTWNLQGQALEQAIISQKPQLEKLIATTAHEKMPWFHGKISREESEQIVLIGSKTNGKFLIRARDNNGSYALCLLHEGKVLHYRIDKDKTGKLSIPEGKKFDTLWQLVEHYSYKADGLLRVLTVPCQKI"
    // );

    formData.append("type", 0);

    let submit_param = {
      type: "Detectability",
      model:"6"
    };
    submit_param = JSON.stringify(submit_param);
    formData.append("param", submit_param);
    formData.append("mail", email);
    enqueueSnackbar("uploading", { variant: "info" });
    // console.log(formData);
    // store.store.servers.request();
    let result = await submitForm(formData);
    console.log(result);
    if (result.success) {
      // store.store.servers.request_success();
      showModal(result.data);
    } else {
      // store.store.servers.request_fail();
      enqueueSnackbar("failed", { variant: "error" });
    }
  };
  useEffect(() => {
    // console.log(defaultTask, fasta);
  }, [defaultTask, fasta]);
  const resetData = useCallback(() => {
    setFasta("");
    setEmail("");
    setDefaultTask("");
  }, []);
  const handleOk = () => {
    setIsModalVisible(false);
    navigate("/tasks");
  };
  return (
    <Box>
      <Dialog open={isModalVisible} onClose={handleOk}>
        <DialogTitle>Your data has been uploaded successfully!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your request time is {resultData.requestTime} and your jobID is{" "}
            {resultData.requestTime.slice(0, 10).split("-").join("") +
              resultData.jobId}{" "}
            please wait.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk}>OK</Button>
        </DialogActions>
      </Dialog>
     
      <Paper elevation={3} sx={{ overflow: "hidden", marginTop: 2 }}>
        <StyledHeader icon={<ArticleOutlined />}>
          Input target sequences
        </StyledHeader>

        <Box padding={2}>
          <FastaForm
            fasta={fasta}
            setFasta={setFasta}
            annotation={true}
            type="Detectability"
            setInputFile={setInputFile}
          />
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ marginTop: 2, overflow: "hidden" }}>
        <StyledHeader icon={<CloudUploadOutlined />}>Submission</StyledHeader>
        <Box margin={2}>
          <TextField
            value={email}
            onChange={({ target: { value } }) => {
              setEmail(value);
            }}
            label="E-mail address"
            fullWidth
            sx={{ mb: 2 }}
          />
          <Typography variant="body2" component="div" marginBottom={2}>
            Model training usually takes a long time, depending on the size of
            the data. Hence, we strongly recommend you to leave your e-mail
            address below so that you will be notified by email when the job is
            done.
          </Typography>
          <Box marginTop={2}>
            <LoadingButton
              onClick={submit}
              loading={uploading}
              variant="contained"
              loadingPosition="start"
              startIcon={<Upload />}
            >
              submit
            </LoadingButton>
            {/* <Button
              onClick={() => {}}
              variant="contained"
              color="secondary"
              sx={{ marginLeft: 1 }}
            >
              result example
            </Button> */}
            <Button
              onClick={gotoExample}
              variant="contained"
              color="secondary"
              sx={{ marginLeft: 1 }}
            >
              example result
            </Button>
            <Button
              onClick={resetData}
              color="error"
              variant="outlined"
              sx={{ marginLeft: 1 }}
            >
              reset
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
